import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M22 9L12 2 2 9h9v13h2V9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
})), 'DeckSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DeckSharp.js
// module id = 3061
// module chunks = 2